import {
	applySwitchMacAclFilter,
	focusSwitchMacAcl,
	openSwitchMacAclSection,
} from './adapter';
import {
	openSwitchMacAclCreateModal,
	openSwitchMacAclDeleteModal,
	openSwitchMacAclAddAceModal,
	openSwitchMacAclEditAceModal,
	openSwitchMacAclDeleteAceModal,
} from './modal';
import {resolveSwitchMacAcl} from './resolver';

/**
 * Switch MAC ACL.
 *
 * The second MAC ACL tab. No edit: the ACL row offers only adding
 * an entry to it and deleting it. Editing belongs to the entries
 * nested inside, which are rows within a row and not offered.
 *
 * Declares no fields: the agent finds one and opens the form rather than
 * filling it in.
 */
const switchMacAclPlugin = {
	id: 'switch_mac_acl',
	version: 1,
	commandVersion: 1,
	resource: 'switch_mac_acl',
	operations: ['options', 'list', 'edit', 'search', 'create', 'delete', 'add_ace', 'edit_ace', 'delete_ace'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.switch_mac_acls': openSwitchMacAclSection,
	},
	resolvers: {
		switch_mac_acl: resolveSwitchMacAcl,
	},
	filters: {
		switch_mac_acl: (command) =>
			applySwitchMacAclFilter(command.params?.query),
	},
	focusHandlers: {
		switch_mac_acl: (command) =>
			focusSwitchMacAcl(command.params?.entity_id),
	},
	modals: {
		'switch_mac_acl.create': openSwitchMacAclCreateModal,
		'switch_mac_acl.delete': openSwitchMacAclDeleteModal,
		'switch_mac_acl.add_ace': openSwitchMacAclAddAceModal,
		'switch_mac_acl.edit_ace': openSwitchMacAclEditAceModal,
		'switch_mac_acl.delete_ace': openSwitchMacAclDeleteAceModal,
	},
};

export default switchMacAclPlugin;
